import React , {useEffect, useLayoutEffect, useState} from 'react'
import apis from  '../../api'
import './components.css'

export default ()=> {
    const [defaultValues, setDefaultValues] = useState({ fpsid: '' , merchantName: ''})
    useLayoutEffect( ()=>{
        const fetchDefaults = async() => {
            var fps = await apis.getDefaultByKey('FPSIdentifier'); 
            fps = fps.toString().replaceAll ('\"' , '');
            // setDefaultValues({...defaultValues , fpsid: fps});
        
            var m_name = await apis.getDefaultByKey('MerchantName');
            m_name = m_name.toString().replaceAll ('\"' , '');
            setDefaultValues({...defaultValues , fpsid: fps ,  merchantName: m_name});
        }
        fetchDefaults();
    } , [])

    let billRefOptions = [ ] 
    billRefOptions.push({val: "01", text: "Bill Number" , default: false})
    billRefOptions.push({val: "05", text: "Reference Label" , default: true})
    return (
            <div> 
                <h2>WVHK FPS Information:</h2>
                <div className='panel'>
                    <label>WVHK FPS ID</label>
                    
                    <input 
                        type='text'
                        readonly 
                        value= {defaultValues.fpsid}
                        id="FPSIdentifier"
                        style={{backgroundColor: "#f0f0f0"}}
                    />
                    <label>Merchant Name</label>
                    <input 
                        type='text'
                        readonly 
                        value={defaultValues.merchantName}
                        id="MerchantName"
                        style={{backgroundColor: "#f0f0f0"}}

                    />
                    <label>Use Bill Number/Reference Label</label>
                    <select 
                        id="BillNumberReferenceLabelPrefix"
                    >
                        {
                            billRefOptions.map((br)=>{
                                return <option value={br.val}
                                        selected={br.default}>
                                    {br.text}</option> 
                            })
                        }
                    </select>
                </div>
            </div>
        )
}
